var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg26Support(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a`"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 53,
    width: 4,
    height: 10,
    style: {
      fill: "#f2b3a2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 53,
    width: 4,
    height: 10,
    style: {
      fill: "#ffecdb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,63v-10h4v-9c0-2.209-1.791-4-4-4H20c-2.209,0-4,1.791-4,4v9h4v10h24Z",
    style: {
      fill: "#415fb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,44v9h-4v10h-4.97c-5.94-4.73-10.03-11.59-10.03-23h15c2.21,0,4,1.79,4,4Z",
    style: {
      fill: "#577ef2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,48c-.552,0-1,.448-1,1v14h2v-14c0-.552-.448-1-1-1Z",
    style: {
      fill: "#314788"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,48c-.552,0-1,.448-1,1v14h2v-14c0-.552-.448-1-1-1Z",
    style: {
      fill: "#415fb5"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 42,
    width: 2,
    height: 21,
    style: {
      fill: "#273640"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,37c-1.657,0-3,1.791-3,4s1.343,4,3,4c0-1.657,1.343-3,3-3v-5h-3Z",
    style: {
      fill: "#314788"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,37c1.657,0,3,1.791,3,4,0,2.209-1.343,4-3,4,0-1.657-1.343-3-3-3v-5h3Z",
    style: {
      fill: "#415fb5"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,22c-.552,0-1-.447-1-1V13c0-6.065-4.935-11-11-11s-11,4.935-11,11v8c0,.553-.448,1-1,1s-1-.447-1-1V13c0-7.168,5.832-13,13-13s13,5.832,13,13v8c0,.553-.448,1-1,1Z",
    style: {
      fill: "#1d252d"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,34v6c0,1.105,.895,2,2,2s2-.895,2-2v-6h-4Z",
    style: {
      fill: "#f2b3a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,37.29v2.71c0,1.1-.9,2-2,2,0-2.17,.83-4.03,2-4.71Z",
    style: {
      fill: "#ffecdb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,29h-4c-1.105,0-2-.895-2-2v-4c0-1.105,.895-2,2-2h4v8Z",
    style: {
      fill: "#273640"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,29h4c1.105,0,2-.895,2-2v-4c0-1.105-.895-2-2-2h-4v8Z",
    style: {
      fill: "#273640"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,21v7c0,4.971,4.029,9,9,9s9-4.029,9-9v-7H23Z",
    style: {
      fill: "#f2b3a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,21v7c0,4.97-4.03,9-9,9-.48,0-.95-.04-1.41-.11-2.68-3.91-4.74-9.45-5.79-15.89h16.2Z",
    style: {
      fill: "#ffecdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,21v7c0-2.71-4.12-5-9-5s-9,2.29-9,5v-7h18Z",
    style: {
      fill: "#f2b3a2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,4c-6.627,0-12,5.373-12,12,0,2.361,.822,4.817,2,7,0-2.209,4.477-4,10-4s10,1.791,10,4c1.178-2.183,2-4.639,2-7,0-6.627-5.373-12-12-12Z",
    style: {
      fill: "#97092f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,16c0,2.36-.82,4.82-2,7,0-2.21-4.48-4-10-4-.81,0-1.6,.04-2.36,.12-1.05-4.26-1.64-9.05-1.64-14.12v-.32c1.25-.44,2.6-.68,4-.68,6.63,0,12,5.37,12,12Z",
    style: {
      fill: "#b50b38"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,19v-7c0-1.105,.895-2,2-2h12c1.105,0,2,.895,2,2v7H24Z",
    style: {
      fill: "#c8c2b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,12v7h-10.39c-.68-2.8-1.17-5.82-1.42-9h9.81c1.1,0,2,.9,2,2Z",
    style: {
      fill: "#e7e5e0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42,21c0-3.314-4.477-6-10-6s-10,2.686-10,6v7c0-3.314,4.477-6,10-6s10,2.686,10,6v-7Z",
    style: {
      fill: "#b50b38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,21v7c0-3.31-4.48-6-10-6-.52,0-1.03,.02-1.53,.08-.67-2.1-1.22-4.37-1.62-6.77,.99-.2,2.05-.31,3.15-.31,5.52,0,10,2.69,10,6Z",
    style: {
      fill: "#f20f4b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32,34h-12c-.552,0-1-.447-1-1v-4c0-.553,.448-1,1-1s1,.447,1,1v3h11c.552,0,1,.447,1,1s-.448,1-1,1Z",
    style: {
      fill: "#202d35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,35h-2c-1.104,0-2-.896-2-2s.896-2,2-2h2c1.104,0,2,.896,2,2s-.896,2-2,2Z",
    style: {
      fill: "#1d252d"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,46c-2.206,0-4-2.243-4-5s1.794-5,4-5c.552,0,1,.447,1,1s-.448,1-1,1c-1.084,0-2,1.374-2,3,0,1.204,.502,2.27,1.203,2.742,.529-1.592,2.031-2.742,3.797-2.742,.552,0,1,.447,1,1s-.448,1-1,1c-1.103,0-2,.897-2,2,0,.553-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,46c-.552,0-1-.447-1-1,0-1.103-.897-2-2-2-.552,0-1-.447-1-1s.448-1,1-1c1.766,0,3.269,1.15,3.797,2.742,.701-.473,1.203-1.538,1.203-2.742,0-1.626-.916-3-2-3-.552,0-1-.447-1-1s.448-1,1-1c2.206,0,4,2.243,4,5s-1.794,5-4,5Zm1-1h0Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,64c-.552,0-1-.447-1-1v-19c0-2.757,2.243-5,5-5h6c.552,0,1,.447,1,1s-.448,1-1,1h-6c-1.654,0-3,1.346-3,3v19c0,.553-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,64c-.552,0-1-.447-1-1v-19c0-1.654-1.346-3-3-3h-6c-.552,0-1-.447-1-1s.448-1,1-1h6c2.757,0,5,2.243,5,5v19c0,.553-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,64c-.552,0-1-.447-1-1v-14c0-.553,.448-1,1-1s1,.447,1,1v14c0,.553-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,64c-.552,0-1-.447-1-1v-14c0-.553,.448-1,1-1s1,.447,1,1v14c0,.553-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,54h-4c-.552,0-1-.447-1-1s.448-1,1-1h4c.552,0,1,.447,1,1s-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,54h-4c-.552,0-1-.447-1-1s.448-1,1-1h4c.552,0,1,.447,1,1s-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32,43c-1.654,0-3-1.346-3-3v-3c0-.553,.448-1,1-1s1,.447,1,1v3c0,.552,.449,1,1,1s1-.448,1-1v-3c0-.553,.448-1,1-1s1,.447,1,1v3c0,1.654-1.346,3-3,3Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,38c-5.514,0-10-4.486-10-10v-3c0-.553,.448-1,1-1s1,.447,1,1v3c0,4.411,3.589,8,8,8s8-3.589,8-8v-3c0-.553,.448-1,1-1s1,.447,1,1v3c0,5.514-4.486,10-10,10Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,29c-.552,0-1-.447-1-1,0-2.71-4.122-5-9-5s-9,2.29-9,5c0,.553-.448,1-1,1s-1-.447-1-1v-7c0-3.925,4.832-7,11-7s11,3.075,11,7v7c0,.553-.448,1-1,1Zm-10-8c3.761,0,7.025,1.144,9,2.925v-2.925c0-2.71-4.122-5-9-5s-9,2.29-9,5v2.925c1.975-1.781,5.239-2.925,9-2.925Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.999,24c-.16,0-.323-.038-.474-.12-.486-.262-.667-.868-.406-1.354,1.23-2.28,1.88-4.537,1.88-6.525,0-6.065-4.935-11-11-11s-11,4.935-11,11c0,1.988,.65,4.245,1.88,6.525,.262,.486,.081,1.093-.406,1.354-.487,.264-1.093,.081-1.355-.405-1.387-2.571-2.12-5.156-2.12-7.475,0-7.168,5.832-13,13-13s13,5.832,13,13c0,2.318-.733,4.903-2.12,7.475-.181,.335-.525,.525-.881,.525Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,18c-.552,0-1-.447-1-1v-5c0-.552-.449-1-1-1h-12c-.551,0-1,.448-1,1v5c0,.553-.448,1-1,1s-1-.447-1-1v-5c0-1.654,1.346-3,3-3h12c1.654,0,3,1.346,3,3v5c0,.553-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,30h-4c-1.654,0-3-1.346-3-3v-4c0-1.654,1.346-3,3-3h3c.552,0,1,.447,1,1s-.448,1-1,1h-3c-.551,0-1,.448-1,1v4c0,.552,.449,1,1,1h4c.552,0,1,.447,1,1s-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,30h-4c-.552,0-1-.447-1-1s.448-1,1-1h4c.551,0,1-.448,1-1v-4c0-.552-.449-1-1-1h-3c-.552,0-1-.447-1-1s.448-1,1-1h3c1.654,0,3,1.346,3,3v4c0,1.654-1.346,3-3,3Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,22c-.552,0-1-.447-1-1V13c0-6.065-4.935-11-11-11s-11,4.935-11,11v8c0,.553-.448,1-1,1s-1-.447-1-1V13c0-7.168,5.832-13,13-13s13,5.832,13,13v8c0,.553-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,34h-12c-.552,0-1-.447-1-1v-4c0-.553,.448-1,1-1s1,.447,1,1v3h11c.552,0,1,.447,1,1s-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,35h-2c-1.104,0-2-.896-2-2s.896-2,2-2h2c1.104,0,2,.896,2,2s-.896,2-2,2Z",
    style: {
      fill: "#222325"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32,64c-.552,0-1-.447-1-1v-21c0-.553,.448-1,1-1s1,.447,1,1v21c0,.553-.448,1-1,1Z",
    style: {
      fill: "#222325"
    }
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ae"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "af"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg26Support);
export default __webpack_public_path__ + "static/media/26-support.c39c355bd1942dee7e5e59aa3a0ea694.svg";
export { ForwardRef as ReactComponent };